import { cloneDeep } from 'lodash';
import { useCallback } from 'react';
import { ITimeCardsSettings } from 'types/TimeCardsSettings';
import useMemberFeatureSettingsUpdate from '../member/useMemberFeatureSettingsUpdate';
import useMemberSettings from '../member/useMemberSettings';

export default function useTimeCardsSettingsUpdate() {
  const memberSettings = useMemberSettings();
  const updateFeatureSettings = useMemberFeatureSettingsUpdate();

  return useCallback(
    <K extends keyof ITimeCardsSettings>(keysAndPayloads: { key: K; payload: ITimeCardsSettings[K] }[]) => {
      const cloned = cloneDeep(memberSettings?.web?.features?.timeCards);

      const mapped = keysAndPayloads.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.key]: cur.payload,
        }),
        cloned
      );

      return updateFeatureSettings('timeCards', mapped);
    },
    [memberSettings, updateFeatureSettings]
  );
}
